<!--
  - Copyright (C) 2020. Archimedes Exhibitions GmbH,
  - Saarbrücker Str. 24, Berlin, Germany
  -
  - This file contains proprietary source code and confidential
  - information. Its contents may not be disclosed or distributed to
  - third parties unless prior specific permission by Archimedes
  - Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
  - to copies made in any form and using any medium. It applies to
  - partial as well as complete copies.
  -->

<template>
  <b-container class="py-4">
    <div class="py-4">
      <h1>Documentaion</h1>
      <p>
        The EMS is a customised framework of services built to manage content and automate
        an exhibition. Such a framework equips the user to have full control over an
        exhibition
        at various levels with the support of a web application, while giving the
        necessary
        status information about all exhibits.
      </p>
    </div>

    <b-row>
      <b-col v-for="item in content" :key="item.title" sm="12" md="6" lg="4" class="my-4">
        <b-card
          :title="item.title" :img-src="getImgUrl(item.img_src)"
          :img-alt="item.img_alt" img-top class="mb-2">
          <b-card-text>{{ item.text }}</b-card-text>
          <b-button :to="{ name: 'docsDetails', params: { section: item.link }}" variant="primary">View docs</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'Docs',
    data () {
      return {
        content: [
          {
            title: 'BPTC Layouts',
            img_src: 'card_header_help_layouts.jpg',
            img_alt: 'Service & Support',
            text: 'Various layouts are available for the exhibits on Sanzos campus. All referred layouts used in the cms are listed in this section.',
            link: 'bptc-exhibit-layout'
          },
          {
            title: 'CMS',
            img_src: 'card_header_help_content.jpg',
            img_alt: 'Content Management System',
            text: 'The content management system forms the essential platform to upload content and organise it into defined layouts for different exhibits.',
            link: 'cms'
          },
          {
            title: 'Power',
            img_src: 'card_header_help_power.jpg',
            img_alt: 'The Powervisor',
            text: 'The Power management module controls the images of all exhibits along with having a clear overview for troubleshooting.',
            link: 'power-management'
          },
          {
            title: 'Scheduling',
            img_src: 'card_header_help_timeline.jpg',
            img_alt: 'The Timeline',
            text: 'The EMS has the ability to schedule content in many ways. That is, a user can orchestrate seasonal or unique content.',
            link: 'scheduling'
          },
          {
            title: 'DirectControl',
            img_src: 'card_header_help_control.jpg',
            img_alt: 'DirectControl',
            text: 'On the DirectControl view, client commands can be issued directly without scheduling them on the timeline.',
            link: 'direct-control'
          },
          {
            title: 'Service & Support',
            img_src: 'card_header_help_content.jpg',
            img_alt: 'Service & Support',
            text: 'On the DirectControl view, client commands can be issued directly without scheduling them on the timeline.',
            link: 'service-support'
          }
        ]
      }
    },
    methods: {
      getImgUrl (pic) {
        return require('../assets/docs/' + pic)
      }
    }
  }
</script>

<style scoped>

</style>
